import Typography from "@mui/material/Typography";

import { INTEGRATION_PROVIDERS_BY_ID } from "@app/common/constants/providers";
import type { IntegrationProviderId } from "@app/common/types";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";
import { Bold } from "@rui/styles";

interface AdditionalPermissionsRequiredModalProps
  extends Omit<ConfirmationModalProps, "children"> {
  providerId: IntegrationProviderId;
}

const AdditionalPermissionsRequiredModal = ({
  providerId,
  ...modalProps
}: AdditionalPermissionsRequiredModalProps) => {
  const providerConfig = INTEGRATION_PROVIDERS_BY_ID[providerId];

  return (
    <ConfirmationModal
      {...modalProps}
      title="Heads up!"
      confirmProps={{ label: "Grant permissions" }}
      cancelProps={{ label: "Cancel" }}
    >
      <Typography variant="bodyPrimaryReg" color="shades.neutral.700">
        To enable <Bold>{providerConfig.displayName}</Bold>, Read needs
        additional permissions.
      </Typography>
    </ConfirmationModal>
  );
};

export default AdditionalPermissionsRequiredModal;
